import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import cvExperience from "../../data/experience";

export default function Experience() {
  return (
    <Container fluid id="experience">
      <Row className="experience-section justify-content-center">
        <Col className="container-default">
          <h2 className="title">
            <span>{"{"}</span>relevant_experience<span>{"}"}</span>
          </h2>
          <p className="experience-section--summary">
            Full Stack Engineer with experience building scalable web platforms
            and distributed systems using modern JavaScript technologies.
            Skilled in front-end delivery with React and backend design with
            Node.js and NestJS, including microservices, REST APIs, and cloud
            infrastructure.
          </p>

          <div className="experience-list">
            {cvExperience.map((item, index) => (
              <div className="experience-item" key={index}>
                <div className="experience-item--meta">
                  <span>{item.company}</span>
                  <span>{item.country}</span>
                  <span>{item.year}</span>
                  <span>{item.role}</span>
                </div>
                <p className="experience-item--summary">{item.summary}</p>
                {item.details && item.details.length > 0 && (
                  <ul className="experience-item--details">
                    {item.details.map((detail, detailIndex) => (
                      <li key={detailIndex}>{detail}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </Col>
      </Row>
    </Container>
  );
}
